// extracted by mini-css-extract-plugin
module.exports = {"auto":"location_auto__3LEFY"};